import React from "react";
import { MENU_DROPDOWN_BANNER_WEB } from "../../helpers/brazePlacementIds";
import BrazePlacementBanner from "../UserSelections/BrazePlacementBanner";
import styles from "./menuDropdownBrazeBanner.module.scss";

/** Inline banner at the bottom of the desktop MENU dropdown (175×128px). */
const MenuDropdownBrazeBanner: React.FC = () => (
  <BrazePlacementBanner
    placementId={MENU_DROPDOWN_BANNER_WEB}
    className={styles.menuDropdownBannerSlot}
    ariaLabel="Menu dropdown promotion"
    logLabel="MenuDropdownBrazeBanner"
  />
);

export default MenuDropdownBrazeBanner;
